import { useSelector, useDispatch } from "react-redux";
import {
    useTheme,
    Container,
    Stack,
    Typography,
    TextField,
} from "@mui/material";
import { PermIdentity } from "@mui/icons-material";
import { grey } from "@mui/material/colors";

import { setBnEin, selectBnEin } from "../slice";

const BusinessNumberStep = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const bnein = useSelector(selectBnEin);

    return (
        <Container maxWidth="md" sx={{ my: 6 }}>
            <Stack gap={2} alignItems="center">
                <PermIdentity
                    fontSize="large"
                    sx={{
                        color: grey[500],
                        ...theme.applyStyles("dark", { color: grey[400] }),
                    }}
                />
                <Typography fontWeight="500" color="text.mediumDark">
                    Add your Business Number or Employer Identification Number
                </Typography>
                <TextField
                    color="secondary"
                    value={bnein}
                    onChange={(e) => dispatch(setBnEin(e.target.value))}
                    placeholder="BN/EIN"
                    autoFocus
                    fullWidth
                    sx={{ maxWidth: 400 }}
                />
            </Stack>
        </Container>
    );
};

export default BusinessNumberStep;
